import { CMSComponentConfig } from '@spartacus/core';

import { AnchorBlocComponent } from '../../components/cms/anchor-bloc/anchor-bloc.component';
import { MultimediaModuleComponent } from '../../components/cms/multimedia-module/multimedia-module.component';
import { Rotating360WrapperComponent } from '../../components/cms/rotating-360-wrapper/rotating-360-wrapper.component';
import { TableComponent } from '../../components/cms/table/table.component';
import { TilesModuleComponent } from '../../components/cms/tiles-module/tiles-module.component';
import { VideoSequencerComponent } from '../../components/cms/video-sequencer/video-sequencer.component';
import { AccordionGroupImageModuleComponent } from '../../components/cms/accordion-group-image-module/accordion-group-image-module.component';
import { ApplicationPushComponent } from '../../components/cms/application-push/application-push.component';
import { PaymentModeComponent } from '../../components/cms/payment-mode/payment-mode.component';
import { PushCardPanelComponent } from '../../components/cms/push-card-panel/push-card-panel.component';
import { RepairCommitmentSearchComponent } from '../../components/cms/repair-commitment-search/repair-commitment-search.component';
import { TextQuoteComponent } from '../../components/cms/text-quote/text-quote.component';
import { VisualCardsModuleComponent } from '../../components/cms/visual-cards-module/visual-cards-module.component';
import { VisualQuoteModuleComponent } from '../../components/cms/visual-quote-module/visual-quote-module.component';
import { ArgumentsComponent } from '../../components/cms/arguments/arguments.component';
import { CrossSellComponent } from '../../components/cms/cross-sell/cross-sell.component';
import { EditorialComponent } from '../../components/cms/editorial/editorial.component';
import { FootnoteComponent } from '../../components/cms/footnote/footnote.component';
import { LegalFooterModuleComponent } from '../../components/cms/legal-footer-module/legal-footer-module.component';
import { LinkCardModuleComponent } from '../../components/cms/link-card-module/link-card-module.component';
import { FAQVPCCMSParagraphComponent } from '../../components/cms/faq-vpc-cms-paragraph/faq-vpc-cms-paragraph.component';
import { HeaderModuleComponent } from '../../components/cms/header-module/header-module.component';
import { ReinsuranceFooterModuleComponent } from '../../components/cms/reinsurance-footer-module/reinsurance-footer-module.component';
import { PushCardComponent } from '../../components/cms/push-card/push-card.component';
import { PushCardSliderModuleComponent } from '../../components/cms/push-card-slider-module/push-card-slider-module.component';
import { SeoModuleComponent } from '../../components/cms/seo-module/seo-module.component';
import { SocialNetworkModuleComponent } from '../../components/cms/social-network-module/social-network-module.component';
import { TeaserModuleComponent } from '../../components/cms/teaser-module/teaser-module.component';
import { SisCategoriesComponent } from '../../components/static/sis-categories/sis-categories.component';
import { CustomCmsLinkDSComponent } from '../../components/cms/cms-link-ds/cms-link-ds.component';
import { WarrantyComponent } from '../../components/cms/warranty/warranty.component';
import { PromoBannerComponent } from '../../components/cms/promo-banner/promo-banner.component';
import { WysiwygModuleComponent } from '../../components/cms/wysiwyg/wysiwyg.component';
import { CmsTabParagraphComponent } from '../../components/cms/cms-tab-paragraph/cms-tab-paragraph.component';
import { ServiceOptionsComponent } from '../../components/cms/service-options/service-options.component';
import { FAQComponent } from '../../components/cms/faq/faq.component';
import { IFUComponent } from '../../components/cms/ifu/ifu.component';
import { ProductComparatorComponent } from '../../components/cms/product-comparator/product-comparator.component';
import { TrimanComponent } from '../../components/cms/triman/triman.component';
import { TipsParagraphComponent } from '../../components/cms/tips-paragraph/tips-paragraph.component';
import { RecipeListComponent } from '../../components/cms/recipe-list/recipe-list.component';
import { ArgumentsSliderModuleComponent } from '../../components/cms/arguments-slider-module/arguments-slider-module.component';
import { ZoovuCMSComponent } from '../../components/cms/zoovu-cms/zoovu-cms.component';
import { UberallCMSComponent } from '../../components/cms/uberall-cms/uberall-cms.component';
import { PushCardBannerModuleComponent } from '../../components/cms/push-card-banner-module/push-card-banner-module.component';
import { NavigationBlocModuleComponent } from '../../components/cms/navigation-bloc-module/navigation-bloc-module.component';
import { NavigationFooterModuleComponent } from '../../components/cms/navigation-footer-module/navigation-footer-module.component';
import { SliderHobComponent } from '../../components/cms/slider-hob/slider-hob.component';
import {
  PointOfServiceComponent
} from '../../components/cms/point-of-service/point-of-service.component';
import {
  ShoppableContentComponent
} from '../../components/cms/shoppable-content/shoppable-content.component';
import { IadvizeStarterComponent } from '../../components/cms/iadvize-starter/iadvize-starter.component';

export const cmsComponentsConfig: CMSComponentConfig = {
  AnchorBlocComponent: {
    component: AnchorBlocComponent
  },
  SimpleMultimediaModuleComponent: {
    component: MultimediaModuleComponent
  },
  NavigationBlocModuleComponent: {
    component: NavigationBlocModuleComponent
  },
  Rotating360WrapperComponent: {
    component: Rotating360WrapperComponent
  },
  TableComponent: {
    component: TableComponent
  },
  TilesModuleComponent: {
    component: TilesModuleComponent
  },
  VideoSequencerComponent: {
    component: VideoSequencerComponent
  },
  AccordionGroupImageModuleComponent: {
    component: AccordionGroupImageModuleComponent
  },
  ApplicationPushComponent: {
    component: ApplicationPushComponent
  },
  PaymentModeComponent: {
    component: PaymentModeComponent
  },
  PointOfServiceComponent: {
    component: PointOfServiceComponent
  },
  PushCardPanelComponent: {
    component: PushCardPanelComponent
  },
  RepairCommitmentSearchComponent: {
    component: RepairCommitmentSearchComponent
  },
  TextQuoteComponent: {
    component: TextQuoteComponent
  },
  VisualCardModuleComponent: {
    component: VisualCardsModuleComponent
  },
  VisualQuoteModuleComponent: {
    component: VisualQuoteModuleComponent
  },
  ArgumentsComponent: {
    component: ArgumentsComponent
  },
  CrossSellComponent: {
    component: CrossSellComponent
  },
  EditorialComponent: {
    component: EditorialComponent
  },
  FootnoteComponent: {
    component: FootnoteComponent
  },
  LegalFooterModuleComponent: {
    component: LegalFooterModuleComponent
  },
  LinkCardModuleComponent: {
    component: LinkCardModuleComponent
  },
  FAQVPCCMSParagraphCmp: {
    component: FAQVPCCMSParagraphComponent
  },
  NavigationFooterModuleComponent: {
    component: NavigationFooterModuleComponent
  },
  HeaderModuleComponent: {
    component: HeaderModuleComponent
  },
  NewsletterComponent: {
    component: () => import('../../components/cms/newsletter/newsletter.component').then(
      (m) => m.NewsletterComponent
    ),
    disableSSR: true
  },
  NewsletterSocialFooterModuleComponent: {
    component: () => import('../../components/cms/newsletter-social-footer-module/newsletter-social-footer-module.component').then(
      (m) => m.NewsletterSocialFooterModuleComponent
    ),
    disableSSR: true
  },
  PrudsysCrossSellComponent: {
    component: () => import('../../components/cms/prudsys-cross-sell/prudsys-cross-sell.component').then(
      (m) => m.PrudsysCrossSellComponent
    ),
    disableSSR: true
  },
  ReinsuranceFooterModuleComponent: {
    component: ReinsuranceFooterModuleComponent
  },
  PushCardComponent: {
    component: PushCardComponent
  },
  PushCardSliderModuleComponent: {
    component: PushCardSliderModuleComponent
  },
  SeoModuleComponent: {
    component: SeoModuleComponent
  },
  SocialNetworkModuleComponent: {
    component: SocialNetworkModuleComponent
  },
  TeaserModuleComponent: {
    component: TeaserModuleComponent
  },
  SisCategoriesComponent: {
    component: SisCategoriesComponent
  },
  CMSLinkDSComponent: {
    component: CustomCmsLinkDSComponent
  },
  WarrantyComponent: {
    component: WarrantyComponent
  },
  PromoBannerComponent: {
    component: PromoBannerComponent
  },
  WysiwygModuleComponent: {
    component: WysiwygModuleComponent
  },
  CMSTabParagraphComponent: {
    component: CmsTabParagraphComponent
  },
  ServiceOptionsComponent: {
    component: ServiceOptionsComponent
  },
  FAQComponent: {
    component: FAQComponent
  },
  IFUComponent: {
    component: IFUComponent
  },
  ProductComparatorComponent: {
    component: ProductComparatorComponent
  },
  TrimanComponent: {
    component: TrimanComponent
  },
  TipsParagraphComponent: {
    component: TipsParagraphComponent
  },
  RecipeListComponent: {
    component: RecipeListComponent
  },
  ArgumentsSliderModuleComponent: {
    component: ArgumentsSliderModuleComponent
  },
  ProductReferenceCrossSellComponent: {
    component: CrossSellComponent
  },
  ZoovuCMSComponent: {
    component: ZoovuCMSComponent
  },
  UberallCMSComponent: {
    component: UberallCMSComponent
  },
  PushCardBannerModuleComponent: {
    component: PushCardBannerModuleComponent
  },
  SliderHOBComponent: {
    component: SliderHobComponent
  },
  ShoppableContentComponent: {
    component: ShoppableContentComponent
  },
  IAdvizeStarterComponent: {
    component: IadvizeStarterComponent
  }
};
